import Tile from './Tile'

const LAYOUT = [
  ['BTCUSD', 'LTCUSD', 'ETHUSD', 'XRPUSD', 'BCHUSD'],
  ['BTCEUR', 'LTCEUR', 'ETHEUR', 'XRPEUR', 'BCHEUR'],
  ['EURUSD', 'LTCBTC', 'ETHBTC', 'XRPBTC', 'BCHBTC'],
]

export default function Layout() {
  return (
    <div className="mx-auto flex w-full min-w-[60rem] max-w-[76rem] grow flex-col">
      {LAYOUT.map((row, ri) => (
        <div key={ri} className="flex grow flex-row">
          {row.map((ticker) => (
            <Tile ticker={ticker} hoverOffsetX={0} hoverOffsetY={25} />
          ))}
        </div>
      ))}
    </div>
  )
}
